// --------------------------------------------------------------------
// @author: xxx@syg.com(必填, 创建模块的人员)
// @description:
//      这里填写详细说明,主要填写该模块的功能简要
// <br/>Create: 2018-11-23 11:43:49
// --------------------------------------------------------------------
var MainSceneModel = cc.Class({
    ctor: function () {
    },

    properties: {
    },

    initConfig: function () {
    },
});

module.exports = MainSceneModel;
